import { NgModule } from '@angular/core';
import { provideStorage, Storage, StorageConfigToken } from './storage';
export { StorageConfigToken, Storage };
var IonicStorageModule = (function () {
    function IonicStorageModule() {
    }
    IonicStorageModule.forRoot = function (storageConfig) {
        if (storageConfig === void 0) { storageConfig = null; }
        return {
            ngModule: IonicStorageModule,
            providers: [
                { provide: StorageConfigToken, useValue: storageConfig },
                { provide: Storage, useFactory: provideStorage, deps: [StorageConfigToken] },
            ]
        };
    };
    IonicStorageModule.decorators = [
        { type: NgModule, args: [{},] },
    ];
    /** @nocollapse */
    IonicStorageModule.ctorParameters = function () { return []; };
    return IonicStorageModule;
}());
export { IonicStorageModule };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic/storage/dist/index.js
// module id = null
// module chunks = 